import * as echarts from 'echarts';
import { isNil } from 'lodash-es';

interface ChartsData {
  time?: number | string;
  count?: number;
}

export const getChartOption = (data?: ChartsData[], name?: string) => {
  // const formatStr = timeResolution === DateType.CUSTOM || timeResolution === DateType.WEEK ? 'YYYY-MM-DD' : 'YYYY-MM';
  const areaColors = [
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      { offset: 0, color: '#FF4D4F15' },
      { offset: 1, color: '#FF4D4F05' },
    ]),
  ];

  return {
    backgroundColor: 'transparent',
    grid: {
      left: 10,
      right: 10,
      top: 10,
      bottom: 10,
      containLabel: true,
    },
    tooltip: {
      formatter: (items: any) => {
        let { axisValue } = items[0];
        // let firstStr = dayjs(axisValue).format(formatStr);
        let otherStr = '';
        let str = '';

        // 截断 name，最多 15 个字符
        let shortName = (name ?? []).length > 12 ? name?.slice(0, 12) + '...' : name;

        items.forEach((item: any) => {
          const { data, marker } = item;
          otherStr += `<div style="margin-top:8px;width:220px;"><div style="display:flex;justify-content:space-between;align-items:center;"><div><span>${marker}</span>${shortName}</div><div>${
            !isNil(data) ? data + '次' : '-'
          }</div></div>`;
          str = axisValue + otherStr;
        });

        return str;
      },
    },

    color: ['#FFCB47'],
    xAxis: [
      {
        type: 'category',
        data: (data ?? []).map(a => a.time),
        axisLabel: {
          // formatter: function (e: number) {
          //   return dayjs(e).format(formatStr);
          // },
          hideOverlap: true,
        },
        boundaryGap: true, // 或直接删掉
      },
    ],
    yAxis: [
      {
        type: 'value',
      },
    ],
    series: {
      type: 'line',
      data: data?.map(item => item.count),
      connectNulls: true,
      smooth: true,
      symbol: 'circle',
      symbolSize: 2,
      // showSymbol: false, // 只有在 tooltip hover 的时候显示symbol
      itemStyle: {
        // symbol样式
        normal: {
          borderColor: 'rgba(255, 255, 255, 0.2)', // symbol边框颜色
          borderWidth: 6, // symbol边框宽度
        },
      },
      lineStyle: {
        width: 2,
        type: 'solid', //'dotted'点型虚线 'solid'实线 'dashed'线性虚线
      },
      areaStyle: {
        color: areaColors[0],
      },
    },
  };
};
